import { FC } from "react";
import { FormControl } from "@mui/material";
import { NewRequisitionType } from "./types";
import {
  ShortcutsContainer,
  ShortcutsLabel,
  StyledSelect,
  GroupHeader,
  ShortcutMenuItem,
} from "./OrderingShortcuts.styles";

interface OrderingShortcutsProps {
  drafts: NewRequisitionType[];
  onSelectDraft: (order: NewRequisitionType) => void;
}

const getRedrawReason = (order: NewRequisitionType): string => {
  if (order.is_aneuploidy_order) return "Aneuploidy Screen Redraw (QC Fail)";
  if (order.is_carrier_screen_order) return "Unity Screen Redraw (QC Fail)";
  return "Redraw Requested";
};

const getPatientName = (order: NewRequisitionType): string =>
  `${order.first_name || ""} ${order.last_name || ""}`.trim();

export const OrderingShortcuts: FC<OrderingShortcutsProps> = ({
  drafts,
  onSelectDraft,
}) => {
  // Sort by created_at descending (reverse chronological)
  const sortedDrafts = [...drafts].sort(
    (a, b) => (b.created_at || 0) - (a.created_at || 0),
  );

  const handleChange = (value: string) => {
    const selectedDraft = sortedDrafts.find(
      (draft) => draft.unity_complete_id === value,
    );
    if (selectedDraft) {
      onSelectDraft(selectedDraft);
    }
  };

  if (sortedDrafts.length === 0) return null;

  return (
    <ShortcutsContainer>
      <ShortcutsLabel>Ordering shortcuts</ShortcutsLabel>
      <FormControl fullWidth size="small" variant="standard">
        <StyledSelect
          id="ordering-shortcuts-select"
          value=""
          onChange={(e) => handleChange(e.target.value as string)}
          displayEmpty
          disableUnderline
          renderValue={() => "Select one"}
        >
          <GroupHeader>Redraws Needed ({sortedDrafts.length})</GroupHeader>
          {sortedDrafts.map((draft) => (
            <ShortcutMenuItem
              key={draft.unity_complete_id}
              value={draft.unity_complete_id}
            >
              {getPatientName(draft)} - {getRedrawReason(draft)}
            </ShortcutMenuItem>
          ))}
        </StyledSelect>
      </FormControl>
    </ShortcutsContainer>
  );
};
